module.exports = __webpack_public_path__ + "img/img1.27d70ec4.jpg";